module.exports = __webpack_public_path__ + "static/img/door-gc3.aaef9ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/door-gc/door-gc3.jpg
// module id = P+kZ
// module chunks = 0